import { IPaymentConnector } from '~/modules/payment/synchrony/payment-connector';

export const mockPaymentConnectors: IPaymentConnector[] = [
  {
    tenderType: 'Visa',
    connectorHtml: {
      AcceptPageUrl: 'https://mock-payment-gateway.com/accept',
      AcceptPageSubmitUrl: 'https://mock-payment-gateway.com/submit',
      MessageOrigin: 'https://mock-payment-gateway.com',
      AcceptPageContent: '<div>Secure Payment Page</div>',
      NotReloadAcceptPageContentWhenAmountChanged: true,
    },
    config: {
      heading: 'Credit/Debit card',
      subHeading: 'Pay securely with your Visa card', // Used in flexible matcher
      synchronySwitch: false,
      synchronyButtonText: 'Apply Now',
      applyNowLink: 'https://visa.com/apply',
    },
  },
  {
    tenderType: 'Synchrony',
    connectorHtml: {
      AcceptPageUrl: 'https://mock-synchrony.com/accept',
      AcceptPageSubmitUrl: 'https://mock-synchrony.com/submit',
      MessageOrigin: 'https://mock-synchrony.com',
      AcceptPageContent: '<div>Mock Synchrony Payment Page</div>',
      NotReloadAcceptPageContentWhenAmountChanged: true,
    },
    config: {
      heading: 'Synchrony',
      subHeading: '',
      synchronySwitch: true,
      synchronyButtonText: 'Apply with Synchrony',
      applyNowLink: 'https://synchrony.com/apply',
    },
  },
];
